import React from 'react';
import { useP } from '../../i18n/useP';

/**
 * Carte "Lecture" — affiche les 1 à 5 phrases factuelles générées par le
 * moteur backend `generate_readings`. Pas d'animation, pas de toggle.
 * Pastille colorée selon `severity` (alert / watch / info).
 */
export default function EvolutionReadingCard({ patterns, loading, error }) {
  const p = useP();
  if (loading) {
    return (
      <div style={cardStyle}>
        <Header />
        <div style={{ color: 'var(--color-text-muted)', fontSize: 12 }}>{p('Analyse en cours…')}</div>
      </div>
    );
  }
  if (error) {
    return (
      <div style={cardStyle}>
        <Header />
        <div style={{ color: 'var(--terracotta-dark)', fontSize: 12 }}>
          {typeof error === 'string' ? error : p('Erreur de chargement.')}
        </div>
      </div>
    );
  }
  if (!patterns || patterns.length === 0) {
    return (
      <div style={cardStyle}>
        <Header />
        <div style={{ color: 'var(--color-text-muted)', fontSize: 12 }}>{p('Aucune lecture disponible.')}</div>
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <Header />
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {patterns.map(pat => (
          <li key={pat.code} style={listItemStyle}>
            <span style={{ ...dotStyle, background: dotColor(pat.severity) }} />
            <span style={textStyle}>{pat.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Header() {
  const p = useP();
  return (
    <div style={headerStyle}>
      <span aria-hidden style={{ marginRight: 6 }}>💡</span>
      <span>{p('Lecture')}</span>
      <span style={{ marginLeft: 8, color: 'var(--color-text-muted)', fontSize: 10, textTransform: 'none', letterSpacing: 0, fontWeight: 500 }}>
        {p('(Bêta — en test)')}
      </span>
    </div>
  );
}

function dotColor(severity) {
  if (severity === 'alert') return '#BA5D4A';   // terracotta
  if (severity === 'watch') return '#B8862A';   // amber
  return '#5C7A3E';                              // sage
}

const cardStyle = {
  background: '#FDFAF4',
  border: '0.5px solid #EDE8DF',
  borderRadius: 8,
  padding: '12px 14px',
  marginBottom: 14,
};

const headerStyle = {
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontWeight: 600,
  color: '#6b6253',
  marginBottom: 8,
  display: 'flex',
  alignItems: 'center',
};

const listItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
  padding: '4px 0',
};

const dotStyle = {
  display: 'inline-block',
  width: 8,
  height: 8,
  borderRadius: '50%',
  marginTop: 6,
  flexShrink: 0,
};

const textStyle = {
  fontFamily: 'Inter, system-ui, sans-serif',
  fontSize: 12,
  color: '#444',
  lineHeight: 1.5,
  fontVariantNumeric: 'tabular-nums',
};
